import http from "@/utils/http";


export const MessagePushDeptApi = {

    getMessagePushDeptListByCurrentCompany(params) {
        return http.get(`/messagePushDept/getMessagePushDeptListByCurrentCompany`,params)
    },
    getMessagePushDeptTree(){
       return http.get(`/messagePushDept/getMessagePushDeptTree`)  
    },
    addMessagePushDept(data) {
        return http.post(`/messagePushDept/addMessagePushDept`,data)
    },
    deleteMessagePushDept(data) {
        return http.post(`/messagePushDept/deleteMessagePushDept`,data)
    },
}